export const notApplicable = 'N/A';
